import { DragHandleIcon } from '@chakra-ui/icons'
import { Box, Button, Input, Select, Td, Tr } from '@chakra-ui/react'
import { PanelItem, PanelItemUnit } from '../../../../types/bloodWork'

interface ItemRowProps {
  item: PanelItem
  updateFunc: (partial: Partial<PanelItem>) => void
  updateUnitFunc: (unitId: string, partial: Partial<PanelItemUnit>) => void
  addPanelItemUnitFunc: () => void
  removeUnitFunc: (unitId: string) => void
  bloodWorkUnitOptions: React.JSX.Element[]
  dragProvided: any
  dragSnapshot: any
}

export default function ItemRow({
  item,
  updateFunc,
  updateUnitFunc,
  addPanelItemUnitFunc,
  removeUnitFunc,
  bloodWorkUnitOptions,
  dragProvided,
  dragSnapshot,
}: ItemRowProps) {
  const additionalUnits =
    item.units?.filter((unit, unitIdx) => {
      return unitIdx !== 0
    }) ?? []

  return (
    <Tr
      ref={dragProvided.innerRef}
      {...dragProvided.draggableProps}
      bg={
        dragSnapshot.isDragging
          ? 'purple.50'
          : item.archived
          ? 'gray.50'
          : 'white'
      }
      borderLeft={dragSnapshot.isDragging ? '3px solid' : 'none'}
      borderColor='purple.400'
    >
      <Td width='40px'>
        <Box
          {...dragProvided.dragHandleProps}
          cursor='grab'
          display='flex'
          alignItems='center'
          justifyContent='center'
        >
          <DragHandleIcon color='gray.400' />
        </Box>
      </Td>
      <Td>
        <Input
          size='sm'
          placeholder='e.g. Sodium, Potassium, etc...'
          value={item.title}
          onChange={(e) => {
            updateFunc({ title: e.target.value })
          }}
        />
      </Td>
      <Td>
        {item.units?.map((unit, unitIdx) => {
          return (
            <Select
              mb={0.5}
              key={unitIdx}
              size='sm'
              value={unit.id}
              placeholder='Unit'
              onChange={(e) => {
                updateUnitFunc(unit.id, { id: e.target.value })
              }}
            >
              {bloodWorkUnitOptions}
            </Select>
          )
        })}
      </Td>
      <Td>
        {item.units?.map((unit, unitIdx) => {
          return (
            <Box key={unitIdx} mb={0.5}>
              <Input
                size='sm'
                value={unit.referenceRange.bottom}
                maxW='60px'
                onChange={(e) => {
                  updateUnitFunc(unit.id, {
                    referenceRange: {
                      ...unit.referenceRange,
                      bottom: e.target.value,
                    },
                  })
                }}
              />
              {' - '}
              <Input
                size='sm'
                maxW='60px'
                value={unit.referenceRange.top}
                onChange={(e) => {
                  updateUnitFunc(unit.id, {
                    referenceRange: {
                      ...unit.referenceRange,
                      top: e.target.value,
                    },
                  })
                }}
              />
            </Box>
          )
        })}
      </Td>
      <Td>
        {item.units?.map((unit, unitIdx) => {
          return (
            <Box key={unitIdx} mb={0.5}>
              <Input
                size='sm'
                value={unit.optimalRange?.bottom}
                maxW='60px'
                onChange={(e) => {
                  updateUnitFunc(unit.id, {
                    optimalRange: {
                      top: unit.optimalRange?.top ?? '',
                      bottom: e.target.value,
                    },
                  })
                }}
              />
              {' - '}
              <Input
                size='sm'
                maxW='60px'
                value={unit.optimalRange?.top}
                onChange={(e) => {
                  updateUnitFunc(unit.id, {
                    optimalRange: {
                      top: e.target.value,
                      bottom: unit.optimalRange?.bottom ?? '',
                    },
                  })
                }}
              />
            </Box>
          )
        })}
      </Td>
      <Td>
        <Box>
          <Button
            variant='ghost'
            onClick={() => {
              addPanelItemUnitFunc()
            }}
            size='sm'
          >
            Add Unit
          </Button>
        </Box>
        {additionalUnits.map((unit, unitIdx) => {
          return (
            <Box key={unitIdx}>
              <Button
                variant='ghost'
                onClick={() => {
                  removeUnitFunc(unit.id)
                }}
                size='sm'
              >
                Remove Unit
              </Button>
            </Box>
          )
        })}
      </Td>
      <Td>
        <Box>
          <Button
            variant='ghost'
            colorScheme={item.archived ? undefined : 'red'}
            onClick={() => {
              updateFunc({ archived: !item.archived })
            }}
            size='sm'
          >
            {item.archived ? 'Unarchive' : 'Archive'}
          </Button>
        </Box>
      </Td>
    </Tr>
  )
}
